import BaseAPI from './BaseAPI';

// Staff-to-staff flash notifications, under /notify. The server derives the
// sender and the inbox owner from the bearer token, so the client only sends
// the receiver / message / colour.
class NotifyAPI extends BaseAPI {
  constructor() {
    super('notify');
  }

  // POST /notify → { notification }
  send({ receiver, message, colors }) {
    return this.post('', { body: { receiver, message, colors } });
  }

  // GET /notify/inbox → { notifications: [...] }
  inbox() {
    return this.get('/inbox');
  }

  // GET /notify → { notifications: [...] }  (notifications the caller has sent)
  sent() {
    return this.get();
  }

  // POST /notify/:id/ack → { ok: true }  (status: 'viewed')
  ack(idNotify, status) {
    return this.post(`/${idNotify}/ack`, { body: { status } });
  }
}

export const NotifyService = new NotifyAPI();
export default NotifyAPI;
